import { useState } from 'react'

const CONTACT_TYPES = [
  '', 'Individual', 'Company', 'Attorney', 'Expert Witness',
  'Court', 'Insurance', 'Government', 'Vendor', 'Other',
]

const ContactForm = ({ contact, onSave, onCancel, saving }) => {
  const isEdit = !!contact
  const [form, setForm] = useState(() => ({
    fullName: contact?.fullName || '',
    company: contact?.company || '',
    email: contact?.email || '',
    phone: contact?.phone || '',
    contactType: contact?.contactType || '',
    isClient: contact?.isClient || false,
  }))

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!form.fullName.trim()) return
    onSave(form)
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Full Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={form.fullName}
            onChange={(e) => handleChange('fullName', e.target.value)}
            required
            placeholder="Full Name"
            className="w-full px-3 py-2 bg-white border border-gray-200
              rounded-lg text-sm text-gray-900 placeholder:text-gray-500
              focus:outline-none focus:ring-2 focus:ring-cb-accent/30
              focus:border-cb-accent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Company
          </label>
          <input
            type="text"
            value={form.company}
            onChange={(e) => handleChange('company', e.target.value)}
            placeholder="Company"
            className="w-full px-3 py-2 bg-white border border-gray-200
              rounded-lg text-sm text-gray-900 placeholder:text-gray-500
              focus:outline-none focus:ring-2 focus:ring-cb-accent/30
              focus:border-cb-accent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Contact Type
          </label>
          <select
            value={form.contactType}
            onChange={(e) => handleChange('contactType', e.target.value)}
            className="w-full px-3 py-2 bg-white border border-gray-200
              rounded-lg text-sm text-gray-900
              focus:outline-none focus:ring-2 focus:ring-cb-accent/30
              focus:border-cb-accent"
          >
            {CONTACT_TYPES.map((t) => (
              <option key={t} value={t}>{t || '-- Select --'}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            value={form.email}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="email@example.com"
            className="w-full px-3 py-2 bg-white border border-gray-200
              rounded-lg text-sm text-gray-900 placeholder:text-gray-500
              focus:outline-none focus:ring-2 focus:ring-cb-accent/30
              focus:border-cb-accent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Phone
          </label>
          <input
            type="tel"
            value={form.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            placeholder="(555) 123-4567"
            className="w-full px-3 py-2 bg-white border border-gray-200
              rounded-lg text-sm text-gray-900 placeholder:text-gray-500
              focus:outline-none focus:ring-2 focus:ring-cb-accent/30
              focus:border-cb-accent"
          />
        </div>

        <div className="sm:col-span-2 flex items-center gap-3">
          <button
            type="button"
            role="switch"
            aria-checked={form.isClient}
            aria-label="Is Client"
            onClick={() => handleChange('isClient', !form.isClient)}
            className={`relative w-11 h-6 rounded-full transition-colors ${
              form.isClient ? 'bg-cb-accent' : 'bg-gray-200'
            }`}
          >
            <span
              className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white
                rounded-full shadow transition-transform ${
                  form.isClient ? 'translate-x-5' : ''
                }`}
            />
          </button>
          <span className="text-sm text-gray-700">Is Client</span>
        </div>
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
        <button
          type="button"
          onClick={onCancel}
          disabled={saving}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white
            border border-gray-200 rounded-lg hover:bg-gray-50
            transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={saving || !form.fullName.trim()}
          className="px-4 py-2 text-sm font-medium text-white bg-cb-accent
            rounded-lg hover:bg-cb-accent/90 transition-colors shadow-sm
            disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {saving
            ? 'Saving...'
            : isEdit
              ? 'Save Changes'
              : 'Create Contact'}
        </button>
      </div>
    </form>
  )
}

export default ContactForm
